import _taggedTemplateLiteral from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { palette } from '../../styles/theming/Theme';
var dividerColorOptions = {
  light: palette.grey[5],
  regular: palette.grey[8],
  dark: palette.grey[12]
};
var sizeOptions = {
  small: '6px',
  regular: '10px',
  large: '15px'
};
export var Item = styled.li(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-top:\n    ", ";\n  list-style: none;\n  width: 100%;\n  text-align: ", ";\n  border-radius: ", ";\n  color: ", ";\n  cursor: pointer;\n  box-sizing: border-box;\n\n  &:first-child {\n    border-top: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n  }\n\n  p, span, h1, h2, h3, h4, h5, h6 {\n    padding: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (_ref) {
  var hasDivider = _ref.hasDivider,
      dividerColor = _ref.dividerColor;
  return hasDivider ? "1px solid ".concat(dividerColorOptions[dividerColor]) : 'none';
}, function (_ref2) {
  var align = _ref2.align;
  return align || 'left';
}, function (_ref3) {
  var hasBorderRadius = _ref3.hasBorderRadius;
  return hasBorderRadius && '5px';
}, palette.grey[12], function (_ref4) {
  var hasDivider = _ref4.hasDivider,
      hasFirstDivider = _ref4.hasFirstDivider,
      dividerColor = _ref4.dividerColor;
  return hasDivider && hasFirstDivider ? "1px solid ".concat(dividerColorOptions[dividerColor]) : 'none';
}, palette.background, function (_ref5) {
  var size = _ref5.size;
  return "".concat(sizeOptions[size], " 15px");
}, palette.primary.regular);